import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import { _t, managePageHrefLink, managePageHrefLinkMobile } from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

const ComplaintsSidebar = () => {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState("");
  const [matchCount, setMatchCount] = useState(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    handleJquery();
    $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
      if ($(this).hasClass("active")) {
        $(this).attr("data-default-active", "true");
      }
    });
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase().trim();

    if (!term) {
      $(".fk-pos-nav > .fk-pos-nav__list").show();
      $(".fk-pos-nav__sub-list").show();
      $(".fk-sm-nav__bar > .fk-sm-nav__list").show();
      $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
        if ($(this).attr("data-default-active") === "true") {
          $(this).addClass("active").find(".fk-pos-nav__sub").show();
        } else {
          $(this).removeClass("active").find(".fk-pos-nav__sub").hide();
        }
      });
      setMatchCount(null);
      return;
    }

    let count = 0;
    $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
      const $category = $(this);
      const catName = $category.children("a").text().toLowerCase();
      const isCatMatch = catName.includes(term);

      let categoryHasMatches = false;

      $category.find(".fk-pos-nav__sub-list").each(function () {
        const $item = $(this);
        const itemText = $item.text().toLowerCase();

        if (isCatMatch || itemText.includes(term)) {
          $item.show();
          categoryHasMatches = true;
          count++;
        } else {
          $item.hide();
        }
      });

      if (categoryHasMatches || isCatMatch) {
        $category.show().addClass("active");
        $category.find(".fk-pos-nav__sub").show();
      } else {
        $category.hide();
      }
    });

    $(".fk-sm-nav__bar > .fk-sm-nav__list").each(function () {
      const $item = $(this);
      const itemText = $item.text().toLowerCase();
      if (itemText.includes(term)) {
        $item.show();
      } else {
        $item.hide();
      }
    });

    setMatchCount(count);
  }, [searchTerm]);

  const handleJquery = () => {
    var posHasSub = $(".fk-pos-nav__list-has-sub");
    var posSub = $(".fk-pos-nav__sub");
    $(".fk-pos-nav__list-has-sub > a").on("click", function (e) {
      e.preventDefault();
    });
    posHasSub.on("click", function () {
      $(this).find(posSub).slideDown();
      $(this).siblings().find(posSub).slideUp();
      $(this).addClass("active").siblings().removeClass("active");
      $(this).attr("data-default-active", "true").siblings().removeAttr("data-default-active");
    });
  };

  const renderSearchBar = (isMobile = false) => (
    <div className={`complaints-sidebar-search-box ${isMobile ? "mb-3" : "mb-2"}`}>
      <div className="complaints-sidebar-search-wrapper">
        <span className="complaints-sidebar-search-icon">
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          ref={isMobile ? null : searchInputRef}
          type="text"
          className="form-control complaints-sidebar-search-input"
          placeholder={_t(t("Search menus..."))}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setSearchTerm("");
            }
          }}
        />
        {searchTerm && (
          <button
            type="button"
            className="complaints-sidebar-search-clear"
            onClick={() => {
              setSearchTerm("");
              if (!isMobile && searchInputRef.current) {
                searchInputRef.current.focus();
              }
            }}
            title={_t(t("Clear search"))}
          >
            <i className="fa fa-times-circle" aria-hidden="true"></i>
          </button>
        )}
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        .complaints-sidebar-search-box {
          position: relative;
          width: 100%;
        }
        .complaints-sidebar-search-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1.5px solid #d1d5db;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          overflow: hidden;
        }
        .complaints-sidebar-search-wrapper:focus-within {
          border-color: #0a8d6e;
          box-shadow: 0 0 0 3px rgba(10, 141, 110, 0.15);
        }
        .complaints-sidebar-search-icon {
          position: absolute;
          left: 11px;
          color: #0a8d6e;
          font-size: 13px;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }
        .complaints-sidebar-search-input {
          width: 100% !important;
          height: 38px !important;
          border: none !important;
          background: transparent !important;
          padding-left: 33px !important;
          padding-right: 30px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .complaints-sidebar-search-input::placeholder {
          color: #94a3b8 !important;
          font-size: 12.5px !important;
        }
        .complaints-sidebar-search-clear {
          position: absolute;
          right: 8px;
          background: transparent;
          border: none;
          color: #94a3b8;
          padding: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 1;
          z-index: 2;
          transition: color 0.15s ease;
        }
        .complaints-sidebar-scroll {
          height: calc(100vh - 170px) !important;
          max-height: calc(100vh - 170px) !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          scrollbar-width: thin !important;
          scrollbar-color: rgba(0, 0, 0, 0.25) transparent !important;
        }
      `}</style>

      {/* Navigation for Small Screen  */}
      <div className="d-lg-none">
        <div className="row">
          <div className="col-12">
            {renderSearchBar(true)}
            <div className="fk-sm-nav" data-simplebar>
              <ul className="t-list fk-sm-nav__bar flex-row">
                {managePageHrefLinkMobile(
                  "/dashboard/complaints/ComplaintReport",
                  _t(t("Dashboard"))
                )}
                {managePageHrefLinkMobile(
                  "/dashboard/complaints/add-new",
                  _t(t("Add New"))
                )}
                {managePageHrefLinkMobile(
                  "/dashboard/complaints/board",
                  _t(t("Board"))
                )}
                {managePageHrefLinkMobile(
                  "/dashboard/complaints/tickets-list",
                  _t(t("Tickets List"))
                )}
                {managePageHrefLinkMobile(
                  "/dashboard/complaints/resolved-tickets",
                  _t(t("Resolved Tickets"))
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Navigation for large Screen  */}
      <div className="d-none d-lg-block">
        {renderSearchBar(false)}

        <div
          className="fk-scroll--pos-menu complaints-sidebar-scroll"
          style={{ display: searchTerm.trim() && matchCount === 0 ? "none" : undefined }}
        >
          <ul className="t-list fk-pos-nav">
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${
                window.location.pathname.includes("/complaints/") ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Complaints"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                {managePageHrefLink(
                  "/dashboard/complaints/ComplaintReport",
                  _t(t("Dashboard"))
                )}
                {managePageHrefLink(
                  "/dashboard/complaints/add-new",
                  _t(t("Add New"))
                )}
                {managePageHrefLink(
                  "/dashboard/complaints/board",
                  _t(t("Board"))
                )}
                 {managePageHrefLink(
                  "/dashboard/complaints/tickets-list",
                  _t(t("Tickets List"))
                )}
                 {managePageHrefLink(
                  "/dashboard/complaints/resolved-tickets",
                  _t(t("Resolved Tickets"))
                )}
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ComplaintsSidebar;
